import styled from 'styled-components';

const FormContainer = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.form.fieldGap};
`;

export default FormContainer;